module.exports = __webpack_public_path__ + "static/media/Introducción_a_Docker.d5aa3836.png";